export const tableAttributes = {
    responsive: "sm",
    hover: true,
    striped: true,
    borderless: true,
    class: "text-center",
    rtl: true,
}